module.exports = __webpack_public_path__ + "img/vector_maya_02.ce193852.svg";